import React from 'react';

export const BorrowerPricingHeaderSkeleton: React.FC = () => {
  return (
    <div className="relative overflow-hidden flex gap-4 px-4 pt-2 border bg-white rounded-xl shadow">
      <div className="w-full pb-4">
        {/* Tabs Section Skeleton */}
        <div className="flex mb-3 border-b">
          {/* Tab 1 */}
          <div className="flex rounded-t-lg items-center gap-2.5 relative pr-2 p-2 animate-pulse">
            <div className="w-5 h-5 bg-gray-300 rounded"></div>
            <div className="w-24 h-4 bg-gray-300 rounded"></div>
          </div>

          {/* Tab 2 */}
          <div className="flex rounded-t-lg items-center gap-2.5 relative pr-2 p-2 animate-pulse">
            <div className="w-5 h-5 bg-gray-300 rounded"></div>
            <div className="w-24 h-4 bg-gray-300 rounded"></div>
          </div>

          {/* Tab 3 */}
          <div className="flex rounded-t-lg items-center gap-2.5 relative pr-2 p-2 animate-pulse">
            <div className="w-16 h-4 bg-gray-300 rounded"></div>
            <div className="w-5 h-5 bg-gray-300 rounded"></div>
          </div>
        </div>

        {/* Main Content Section */}
        <div>
          <div className="flex gap-4">
            {/* Insured Card Skeleton */}
            <div className="animate-pulse">
              <div className="flex col h-28 items-center gap-2 p-4 border rounded-xl bg-gray-50 w-56">
                <div className="w-12 h-12 bg-gray-300 rounded-full mb-3"></div>
                <div className='flex flex-col'>
                  <div className="w-24 h-4 bg-gray-300 rounded mb-2"></div>
                  <div className="w-16 h-3 bg-gray-300 rounded mb-1"></div>
                  <div className="w-20 h-3 bg-gray-300 rounded"></div>
                </div>
              </div>
            </div>

            {/* Loan Cards Section Skeleton */}
            <div className="relative grow pb-3">
              <div className="flex border rounded-xl h-28 grow overflow-hidden">
                {/* Loan Card 1 */}
                <div className="flex w-full p-4 border-r gap-2 bg-gray-50 animate-pulse">
                  <div className="flex-none h-8 w-8 bg-gray-300 rounded-full"></div>
                  <div className="flex flex-col w-full gap-2">
                    <div className="w-32 h-4 bg-gray-300 rounded"></div>
                    <div className="w-40 h-4 bg-gray-300 rounded"></div>
                    <div className="flex gap-1">
                      <div className="w-12 h-5 bg-gray-300 rounded-full"></div>
                      <div className="w-16 h-5 bg-gray-300 rounded-full"></div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-between gap-2">
                    <div className="w-8 h-8 bg-gray-300 rounded-full"></div>
                    <div className="w-8 h-8 bg-gray-300 rounded-full"></div>
                  </div>
                </div>

                {/* Loan Card 2 */}
                <div className="flex w-full p-4 border-r gap-2 bg-gray-50 animate-pulse">
                  <div className="flex-none h-8 w-8 bg-gray-300 rounded-full"></div>
                  <div className="flex flex-col w-full gap-2">
                    <div className="w-28 h-4 bg-gray-300 rounded"></div>
                    <div className="w-36 h-4 bg-gray-300 rounded"></div>
                    <div className="flex gap-1">
                      <div className="w-12 h-5 bg-gray-300 rounded-full"></div>
                      <div className="w-16 h-5 bg-gray-300 rounded-full"></div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-between gap-2">
                    <div className="w-8 h-8 bg-gray-300 rounded-full"></div>
                    <div className="w-8 h-8 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Search Button Skeleton */}
            <div className="h-28 w-28 animate-pulse">
              <div className="h-full w-full bg-gray-300 rounded-xl flex items-center justify-center">
                <div className="w-8 h-8 bg-gray-400 rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
